import { BaseModel } from '../../_base/crud';

export class FollowUpModel extends BaseModel {
  id: number;
  body: string;
  file: any[];
  tags: any[];
  receiver: any[];
  sender_email: string;
  data: any;
  is_completed: boolean;
  sender_name: string;
  contact_id?: any;
  created_by?: any;
  clear: any;
}
